import { render, staticRenderFns } from "./psuBmPayForm.vue?vue&type=template&id=4a9b5600&scoped=true"
import script from "./psuBmPayForm.vue?vue&type=script&lang=js"
export * from "./psuBmPayForm.vue?vue&type=script&lang=js"
import style0 from "./psuBmPayForm.vue?vue&type=style&index=0&id=4a9b5600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b5600",
  null
  
)

export default component.exports